/* eslint-disable prettier/prettier */
/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-undef */
/* eslint-disable consistent-return */
/* eslint-disable quotes */
import { useState, useEffect, useCallback, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import * as VideoExpress from '@vonage/video-express'
import MuteAudioButton from "../muteAudioButton"
import MuteVideoButton from '../muteVideoButton'
import SpeakerSelector from "../speakerSelector"
import RecordingButton from "../recordingButton"
import LayoutButton from "../layoutButton"
import MuteAll from "../muteAll"
import ReactionsButton from '../reactionButton'
import ScreenSharingButton from "../screenSharingButton"
import EndCallButton from "../endCallButton"
import VideoFilterButton from "../videoFilterButton"
import styles from "./styles"
import { useTheme } from "@material-ui/core"
import MoreOptionsButton from "../MoreOptionsButton"
import TranscriptionButton from '../trasncriptionButton'
import api from '../../../../services/api'
import { useAuth } from '../../../../hooks/auth'
import { useWebSocketContext } from '../../../../hooks/webSocketContext'
import { useVideoCall } from '../../../../hooks/videoCallContext'
import { boolean } from 'yup'



export default function ToolBar({
  room,
  connected,
  cameraPublishing,
  isScreenSharing,
  startScreenSharing,
  stopScreenSharing,
  participants,
  localParticipant,
  role,
  sessionId, 
  userName,
  leaveRoom,
  miniPlayer,
  onLeave,
  roomId
}) {

  const theme = useTheme()
  const { push } = useHistory()
  const [hasAudio, setHasAudio] = useState(Boolean)
  const [hasVideo, setHasVideo] = useState(Boolean)
  const [areAllMuted, setAllMuted] = useState(false)
  const classes = styles()
  const isMobileWidth = useMediaQuery(theme.breakpoints.down("xs"))
  const { user } = useAuth()
  const { ws, connect, disconnect, audioStream,
      audioContextRef,
      sourceRef,
      processorRef,
      setAudioStream } = useWebSocketContext()
  const { roomState, setRoomState } = useVideoCall(roomId)
  const videoRoomProps = roomState?.videoRoomProps || {}

const cleanupAudio = useCallback(() => {
  if (processorRef.current) {
    processorRef.current.disconnect()
    processorRef.current.onaudioprocess = null
    processorRef.current = null
  }
  
  if (sourceRef.current) {
    sourceRef.current.disconnect()
    sourceRef.current = null
  }
  
  if (audioContextRef.current) {
    audioContextRef.current.close().catch(console.error)
    audioContextRef.current = null
  }
  
  if (audioStream) {
    audioStream.getTracks().forEach(track => {
      track.stop()
      track.enabled = false
    })
    setAudioStream(null)
  }
}, [processorRef, sourceRef, audioContextRef, audioStream, setAudioStream])



  // Função para iniciar o fluxo de áudio/transcrição
  const startAudioStream = useCallback(async deviceId => {
    cleanupAudio()
   if (processorRef.current || sourceRef.current) return

    const deviceInfo = await room.camera.getAudioDevice()
    const selectedDeviceId = deviceId || deviceInfo.deviceId

    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        deviceId: { exact: selectedDeviceId },
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 16000
      }
    })

    setAudioStream(stream)
    
    audioContextRef.current = new (window.AudioContext || (window as any).webkitAudioContext)({ sampleRate: 16000 })
    sourceRef.current =   audioContextRef.current.createMediaStreamSource(stream)
    processorRef.current =   audioContextRef.current.createScriptProcessor(4096, 1, 1)

    processorRef.current .onaudioprocess = e => {
      // Só envia áudio se não estiver mutado
      if (ws.current && ws.current.readyState === WebSocket.OPEN &&  room.camera.isAudioEnabled()) {
      console.log("enviando audio")     
        const float32Array = e.inputBuffer.getChannelData(0)
              const int16Array = convertFloat32ToInt16(float32Array)
              ws.current.send(int16Array.buffer)
    }
    }

  sourceRef.current.connect(processorRef.current)
  processorRef.current.connect(audioContextRef.current.destination)

  }, [audioContextRef, processorRef, sourceRef, hasAudio, room])

  function convertFloat32ToInt16(buffer) {
    let l = buffer.length
    const buf = new Int16Array(l)
    while (l--) {
      buf[l] = Math.max(-1, Math.min(1, buffer[l])) * 0x7FFF
    }
    return buf
  }


 // Criação e manutenção do WebSocket (apenas uma vez por sessão)
  useEffect(() => {
    if (!connected || !sessionId || !userName || !room) return
    const wsUrl = `wss://plataforma.smartboard.app.br/audio?sessionId=${sessionId}&userName=${encodeURIComponent(userName)}`
    console.log('ws',ws)
    if(!ws.current){
      console.log('conectando ws...')
      connect(wsUrl)
    }
   
  }, [connected, sessionId, userName, room, connect, ws])
  
  // Troca de device: reinicie o fluxo de áudio
  useEffect( () => {
    console.log(roomState)
    console.log(videoRoomProps)
    if (!room || !connected) return
    console.log('startingAudioStream...')
    startAudioStream(videoRoomProps.user.defaultSettings.audioSource)
    // eslint-disable-next-line
  }, [room, connected])


  const handleMuteAll = () => {
    if (!areAllMuted) {
      participants.map(participant => participant.camera.disableAudio())
      setAllMuted(true)
    } else {
      participants.map(participant => participant.camera.enableAudio())
      setAllMuted(false)
    }
  }
  
  const toggleVideo = () => {
    if (room && room.camera) {
      const { camera } = room
      const isVideoEnabled = camera.isVideoEnabled()
      if (isVideoEnabled) {
        camera.disableVideo()
        setHasVideo(false)
    setRoomState({
          videoRoomProps: {
            ...videoRoomProps,
            user: {
              ...videoRoomProps.user,
              defaultSettings: {
                ...videoRoomProps.user.defaultSettings,
                publishVideo: false
              }
            }
          }
        })
      } else {
        camera.enableVideo()
        setHasVideo(true)
 setRoomState({
          videoRoomProps: {
            ...videoRoomProps,
            user: {
              ...videoRoomProps.user,
              defaultSettings: {
                ...videoRoomProps.user.defaultSettings,
                publishVideo: true
              }
            }
          }
        })
      }
    }
  }

  const toggleAudio = async () => {
    if (room && room.camera) {
      const {camera} = room
      const isAudioEnabled = camera.isAudioEnabled()
    if (isAudioEnabled) {
      room.camera.disableAudio()
      cleanupAudio()
      setHasAudio(false)
    setRoomState({
          videoRoomProps: {
            ...videoRoomProps,
            user: {
              ...videoRoomProps.user,
              defaultSettings: {
                ...videoRoomProps.user.defaultSettings,
                publishAudio: false
              }
            }
          }
        })
    } else {
      room.camera.enableAudio()
      startAudioStream(videoRoomProps.user.defaultSettings.audioSource)
      setHasAudio(true)
 setRoomState({
          videoRoomProps: {
            ...videoRoomProps,
            user: {
              ...videoRoomProps.user,
              defaultSettings: {
                ...videoRoomProps.user.defaultSettings,
                publishAudio: true
              }
            }
          }
        })
      }
    }
  }

  const getVideoSource = () => {
    if (room && room.camera) {
      return room.camera.getVideoDevice()
    }
  }

  const changeVideoSource = videoId => {
    room.camera.setVideoDevice(videoId)
    setRoomState({
      videoRoomProps: {
        ...videoRoomProps,
        user: {
          ...videoRoomProps.user,
          defaultSettings: {
            ...videoRoomProps.user.defaultSettings,
            videoSource: videoId
          }
        }
      }
    })
  }

  const changeAudioSource = async audioId => {
    if (room && room.camera) {
      await room.camera.setAudioDevice(audioId)
       setRoomState({
      videoRoomProps: {
        ...videoRoomProps,
        user: {
          ...videoRoomProps.user,
          defaultSettings: {
            ...videoRoomProps.user.defaultSettings,
            audioSource: audioId
          }
        }
      }
    })
    startAudioStream(audioId)
    }
  }

  const changeAudioOutput = async audioOutputDeviceId => {
  await VideoExpress.setAudioOutputDevice(audioOutputDeviceId)
    setRoomState({
      videoRoomProps: {
        ...videoRoomProps,
        user: {
          ...videoRoomProps.user,
          defaultSettings: {
            ...videoRoomProps.user.defaultSettings,
            audioOutput: audioOutputDeviceId
          }
        }
      }
    })

  }

  const getCurrentAudioOutput = async () => {
    try {
      const currentAudioOutput = await VideoExpress.getActiveAudioOutputDevice()
      return currentAudioOutput.deviceId
    } catch (e) {
      return e
    }
  }

  const getAudioSource = async () => {
    if (room && room.camera) {
      const audioDevice = await room.camera.getAudioDevice()
      return audioDevice.deviceId
    }
  }

  const endCall = async () => {
    if (room) {
      cleanupAudio()
      disconnect()
      leaveRoom()
      await onLeave(roomId)
      push('/atendimento/listar')
    }
  }

  useEffect(() => {
    if (connected) {
      const isAudioEnabled = !!(room && room.camera && room.camera.isAudioEnabled())
      const isVideoEnabled = !!(room && room.camera && room.camera.isVideoEnabled())
      setHasAudio(isAudioEnabled)
      setHasVideo(isVideoEnabled)
    } 
  }, [connected, room])


 const toolbarContainer = miniPlayer
   ?  classes.miniToolbarContainer
    : classes.toolbarContainer

  return isMobileWidth ? (
    <div className={classes.toolbarMobileContainer}>
      <MuteAudioButton toggleAudio={toggleAudio} hasAudio={videoRoomProps.user.defaultSettings.publishAudio} classes={classes} getAudioSource={getAudioSource} cameraPublishing={cameraPublishing} changeAudioSource={changeAudioSource} miniPlayer={miniPlayer} />
      <EndCallButton classes={classes} handleEndCall={endCall} />
      <MuteVideoButton toggleVideo={toggleVideo} hasVideo={videoRoomProps.user.defaultSettings.publishVideo} classes={classes} getVideoSource={getVideoSource} cameraPublishing={cameraPublishing} changeVideoSource={changeVideoSource} miniPlayer={miniPlayer} />
    </div>
  ) : (
    <div className={toolbarContainer}>
      {miniPlayer ? (
        <>
          <MoreOptionsButton classes={classes} participants={participants} room={room} localParticipant={localParticipant} roomId={roomId} miniPlayer={miniPlayer} /> 

          <MuteAudioButton
            toggleAudio={toggleAudio}
            hasAudio={videoRoomProps.user.defaultSettings.publishAudio}
            classes={classes}
            changeAudioSource={changeAudioSource}
            getAudioSource={getAudioSource}
            cameraPublishing={cameraPublishing}
            miniPlayer={miniPlayer}
          />

          <MuteVideoButton
            toggleVideo={toggleVideo}
            hasVideo={videoRoomProps.user.defaultSettings.publishVideo}
            classes={classes}
            getVideoSource={getVideoSource}
            cameraPublishing={cameraPublishing}
            changeVideoSource={changeVideoSource}
            miniPlayer={miniPlayer} 
          />
        </>
      ):(
        <>
          <MoreOptionsButton classes={classes} participants={participants} room={room} localParticipant={localParticipant} roomId={roomId} miniPlayer={miniPlayer}  /> 
          <TranscriptionButton 
            room={room}
            sessionId={sessionId}
            userName={userName}
            classes={classes}
            ws={ws.current}
          />
          <MuteAudioButton
            toggleAudio={toggleAudio}
            hasAudio={videoRoomProps.user.defaultSettings.publishAudio}
            classes={classes}
            changeAudioSource={changeAudioSource}
            getAudioSource={getAudioSource}
            cameraPublishing={cameraPublishing}
            miniPlayer={miniPlayer}
          />

          <MuteVideoButton
            toggleVideo={toggleVideo}
            hasVideo={videoRoomProps.user.defaultSettings.publishVideo}
            classes={classes}
            getVideoSource={getVideoSource}
            cameraPublishing={cameraPublishing}
            changeVideoSource={changeVideoSource}
            miniPlayer={miniPlayer}
          />
          {VideoExpress.hasMediaProcessorSupport() && <VideoFilterButton classes={classes} room={room} roomId={roomId} />} 
          <SpeakerSelector changeAudioOutput={changeAudioOutput} getCurrentAudioOutput={getCurrentAudioOutput} classes={classes} cameraPublishing={cameraPublishing} />
          {/* {role == 'publisher'  && (
      <RecordingButton room={room} classes={classes} /> )} */}
          <ScreenSharingButton
            isScreenSharing={isScreenSharing}
            startScreenSharing={startScreenSharing}
            stopScreenSharing={stopScreenSharing}
            classes={classes}                       
          /> 
          <MuteAll handleMuteAll={handleMuteAll} areAllMuted={areAllMuted} classes={classes} />
          <ReactionsButton classes={classes} room={room} roomId={roomId} /> 
          <LayoutButton classes={classes} room={room} /> 
          <EndCallButton classes={classes} handleEndCall={endCall} />
        </>
    )}
    </div>
  )
}